import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    HYPER_V_1000_DOWNLOAD?: boolean;
    LOG_COLLECTION_HA?: boolean;
    NUTANIX_SCANNER_DOWNLOAD?: boolean;
    BLOCKLIST_DOWNLOAD?: boolean;
    ZOOMIN?: boolean;
  }
}

export default {
  featureFlags: {
    // AWN-220282 - Add hyper-v awn1000
    HYPER_V_1000_DOWNLOAD: undefined,
    // AWN-990795 Add FF for vlc HA frontend
    LOG_COLLECTION_HA: true,
    // SSC-3373 - Provide access to Nutanix vScanner image
    NUTANIX_SCANNER_DOWNLOAD: undefined,
    // LABS-471 Blocklist Downloads
    BLOCKLIST_DOWNLOAD: true,
    ZOOMIN: undefined,
  },
} satisfies FeatureFlagConfig;
